interface IGetCustomListInvitationURL {
  listId: string;
  invitationId?: string;
  isWithDrawal?: boolean;
}

const getCustomListInvitationURL = (
  args: IGetCustomListInvitationURL
): string => {
  const { listId, isWithDrawal, invitationId } = args;

  const urlSuffix = isWithDrawal ? '/withdraw' : '';
  const invitation = invitationId ? `/${invitationId}` : '';

  return `/api/customEntityLists/${listId}/invitations${invitation}${urlSuffix}`;
};

export default getCustomListInvitationURL;
